module.exports = __webpack_public_path__ + "img/04.37bb4136.jpg";